import React, { useState } from 'react';

import AddBookForm from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/AddBookForm';

import NwDrawer from '@components/Gui/NwDrawer';

/**
 * Creazione di un book. `onCreated` riceve il book appena creato: chi lo usa decide se
 * aprirci subito l'editor, aggiungerlo altrove, o entrambe le cose.
 */
const AddBookDrawer = ({ contactID, onClose, onCreated }) => {
    const [touchForm, setTouchForm] = useState(false);

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} title="Add new book" padding={0} onClose={onClose}>
            <div style={{ padding: '1.6rem' }}>
                <AddBookForm
                    contactID={contactID}
                    onClose={onClose}
                    afterCreate={() => {}}
                    onTouchForm={setTouchForm}
                    onSelectBook={onCreated}
                />
            </div>
        </NwDrawer>
    );
};

export default AddBookDrawer;
